import { track } from '@tldraw/tldraw'
import { Button } from 'blaze-ui/Button'
import ArrowSwitchHorizontal from 'blaze-ui/icons/20/ArrowSwitchHorizontal'
import { Color, GradientColor } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { observer } from 'mobx-react-lite'

interface Props {
  selectedColor: GradientColor
  onNewColorChange: (color: Color) => void
  onFlip: () => void
}

export const GradientFlipDirectionButton = track(
  observer(({ selectedColor, onNewColorChange, onFlip }: Props) => {
    const handleDirectionFlip = () => {
      const newColor = {
        angle: selectedColor.angle,
        type: selectedColor.type,
        stops: selectedColor.stops
          .map((s) => ({
            color: s.color,
            position: 1 - s.position,
            opacity: s.opacity,
          }))
          .reverse(),
      }

      onNewColorChange(newColor)
      onFlip()
    }

    return (
      <div style={{ padding: '10px' }}>
        <Button size="md" variant="tertiary" frontIcon={ArrowSwitchHorizontal} fullWidth onPress={handleDirectionFlip}>
          Flip Direction of Colors
        </Button>
      </div>
    )
  }),
)
